import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

// Services
import { CoreService } from '../../services/core.service';

// Slices & Thunks
import { DateSliceActions } from './date.slice';

export enum EDateThunks {
  SetLocalTimeZone = 'DATE/setLocalTimeZone',
  SetSelectedTimeZone = 'DATE/setSelectedTimeZone',
  SaveSelectedTimeZone = 'DATE/saveSelectedTimeZone',
  FetchTimezonesList = 'DATE/fetchTimezonesList',
}

export const setLocalTimeZone = createAsyncThunk(
  EDateThunks.SetLocalTimeZone,
  async ({ timeZone }: { timeZone: string }, { dispatch }) => {
    return dispatch(DateSliceActions.setLocalTimezone(timeZone));
  }
);

export const setSelectedTimeZone = createAsyncThunk(
  EDateThunks.SetSelectedTimeZone,
  async ({ timeZone }: { timeZone: string }, { dispatch }) => {
    return dispatch(DateSliceActions.setSelectedTimezone(timeZone));
  }
);

export const saveSelectedTimeZone = createAsyncThunk(
  EDateThunks.SaveSelectedTimeZone,
  async ({ timeZone }: { timeZone: string }, { dispatch }) => {
    dayjs.tz.setDefault(timeZone);
    return dispatch(DateSliceActions.setSelectedTimezone(timeZone));
  }
);

export const fetchTimezonesList = createAsyncThunk(
  EDateThunks.FetchTimezonesList,
  async (_, { dispatch }) => {
    const { timezones, error } = await CoreService.fetchTimezonesList();

    if (error) {
      console.error('Error fetching timezones:', error);
      return dispatch(DateSliceActions.setTimezonesOptions([]));
    }

    if (timezones && timezones.length > 0) {
      return dispatch(DateSliceActions.setTimezonesOptions(timezones.map((timezone) => ({
        ...timezone,
        label: timezone.name.replace(/_/g, ' ')
      }))));
    }

    return dispatch(DateSliceActions.setTimezonesOptions([]));
  }
);
